.modal {
  display: flex;
  align-items: start;
  justify-content: center;
  overflow-y: auto;
}

.buttons {
  margin-top: 1rem;
}

.button {
  margin-top: 1rem;
  width: 49%;
}

.closeIcon {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
  font-size: 3rem !important;
  color: #888;
  cursor: pointer;
}

.paper {
  position: relative;
  top: 4rem;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 2px rgba(0, 0, 0, 0.5);
  padding: 1.5rem 2rem 2rem;
  min-width: 300px;
  max-width: 800px;
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL0tpb3NrUHJpY2luZ0Zvcm0iLCJzb3VyY2VzIjpbImNsYXNzZXMubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUVBO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5tb2RhbCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBzdGFydDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIG92ZXJmbG93LXk6IGF1dG87XG4gfVxuXG4uYnV0dG9ucyB7XG4gIG1hcmdpbi10b3A6IDFyZW07XG59XG5cbi5idXR0b24ge1xuICBtYXJnaW4tdG9wOiAxcmVtOy8vdGhlbWUuc3BhY2luZygyKTtcbiAgd2lkdGg6IDQ5JTtcbn1cblxuLmNsb3NlSWNvbiB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICByaWdodDogMDtcbiAgcGFkZGluZzogMC41cmVtO1xuICBmb250LXNpemU6IDNyZW0gIWltcG9ydGFudDtcbiAgY29sb3I6ICM4ODg7XG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cblxuLnBhcGVyIHtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICB0b3A6IDRyZW07XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmY7Ly90aGVtZS5wYWxldHRlLmJhY2tncm91bmQucGFwZXI7XG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgYm94LXNoYWRvdzogMnB4IDJweCByZ2JhKDAsIDAsIDAsIDAuNSk7Ly90aGVtZS5zaGFkb3dzWzVdO1xuICBwYWRkaW5nOiAxLjVyZW0gMnJlbSAycmVtO1xuICAvL3BhZGRpbmc6IHRoZW1lLnNwYWNpbmcoMjsgMjsgMyk7XG4gIG1pbi13aWR0aDogMzAwcHg7XG4gIG1heC13aWR0aDogODAwcHg7XG4gIHdpZHRoOiAxMDAlO1xufVxuIl19 */